module.exports = __webpack_public_path__ + "img/amns-logo.40b1a09e.jpg";